import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { FaInfoCircle, FaPhone } from "react-icons/fa";

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto p-4`;

const Grid = tw.div`
  grid 
  grid-cols-1 
  sm:grid-cols-2 
  md:grid-cols-3 
  lg:grid-cols-4
  xl:grid-cols-5
  gap-4
`;

const Card = tw.div`
  h-full flex! flex-col 
  sm:border 
  sm:rounded-tl-4xl sm:rounded-br-5xl 
  relative focus:outline-none
  bg-primary-200
  `;

const CardImage = styled.div(props => [
  `background-image: url("${props.imageSrc}");`,
  tw`w-full h-60 sm:h-70 bg-cover bg-center rounded sm:rounded-none sm:rounded-tl-4xl`
]);

const TextInfo = tw.div`px-4 py-4`;
const TitleReviewContainer = tw.div`flex flex-col sm:flex-row sm:justify-between sm:items-center`;
const Title = tw.h5`text-2xl font-bold`;

const SecondaryInfoContainer = tw.div`flex flex-col mt-2 sm:mt-4`;
const IconWithText = tw.div`flex items-center mr-6 my-2 sm:my-0`;
const IconContainer = styled.div`
  ${tw`inline-block rounded-full p-2 bg-gray-700 text-gray-100`}
  svg {
    ${tw`w-3 h-3`}
  }
`;
const Text = tw.div`ml-2 text-sm font-semibold text-gray-800`;
const Description = tw.p`text-sm leading-loose mt-2 sm:mt-4 whitespace-pre-line`;
const formatPhoneNumber = (phone) => {
  const digits = phone.replace(/[^\d]/g, "");
  if (digits.length === 10) {
    return `+90 ${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6, 8)} ${digits.slice(8)}`;
  }
  return phone.trim(); // Fallback to raw trimmed
};


export default function ContactsGrid({ cards = [], showTitleText = true }) {
  return (
    <Container>
      <Content>
        <Grid>
          {cards.map((card, index) => (
            <Card key={index}>
              <CardImage imageSrc={card.imageSrc} />
              <TextInfo>
                <TitleReviewContainer>
                  <Title>{card.title}</Title>
                </TitleReviewContainer>

                <SecondaryInfoContainer>
                  {showTitleText && card.titleText && (
                    <IconWithText>
                      <IconContainer>
                        <FaInfoCircle />
                      </IconContainer>
                      <Text>{card.titleText}</Text>
                    </IconWithText>
                  )}
                  {typeof card.phoneNumber === "string" && card.phoneNumber.trim() !== "" && (
                    <div tw="mt-2 text-sm text-gray-700 space-y-1">
                      {card.phoneNumber.includes("-")
                        ? card.phoneNumber.split("-").map((num, idx) => (
                          <IconWithText key={idx}>
                            <FaPhone className="text-gray-500 w-3 h-3" />
                            <Text>{formatPhoneNumber(num)}</Text>
                          </IconWithText>
                        ))
                        : (
                          <IconWithText>
                            <FaPhone className="text-gray-500 w-3 h-3" />
                            <Text>{formatPhoneNumber(card.phoneNumber)}</Text>
                          </IconWithText>
                        )
                      }
                    </div>
                  )}


                </SecondaryInfoContainer>


                <Description>{card.description}</Description>
              </TextInfo>
            </Card>
          ))}
        </Grid>
      </Content>
    </Container>
  );
}
